import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { mergeMap, of } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

export const registrationDbAdminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.authReady.pipe(
    mergeMap((authReady) => {
      if (!authReady || !authService.signedIn) {
        return router.navigate(['/login']);
      }
      if (!authService.isRegistrationDbAdmin()) {
        return router.navigate(['']);
      }
      return of(true);
    })
  );
};
